import type { SettingsRowProps } from './Settings.types';
import type { ReactElement } from 'react';

import { Flex, Text } from '@rango-dev/whale';
import clsx from 'clsx';
import { ChevronRight } from 'lucide-react';
import React from 'react';

import styles from './Settings.module.css';

const CHEVRON_SIZE = 20;

export function SettingsRow(props: SettingsRowProps): ReactElement {
  const { id, icon, label, value, hasChevron = true, className, onClick } = props;

  return (
    <button type="button" id={id} className={clsx(styles.row, className)} onClick={onClick}>
      <Flex align="center" gap="2" flexGrow="1" minWidth="0">
        <span className={styles.rowIcon}>{icon}</span>
        <Text size="3" weight="medium" truncate>
          {label}
        </Text>
      </Flex>
      {(value || hasChevron) && (
        <Flex align="center" justify="center" gap="1" flexShrink="0">
          {value && (
            <Text size="1" color="gray">
              {value}
            </Text>
          )}
          {hasChevron && (
            <span className={styles.rowChevron}>
              <ChevronRight size={CHEVRON_SIZE} />
            </span>
          )}
        </Flex>
      )}
    </button>
  );
}
